import React, { useRef } from "react";
import Slider from "react-slick";

const StatSelection = (props) => {
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => ('');
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => ('');

  const formatStat = (stat) => {
    if (stat == 'Popular') {
      return '🔥 Popular';
    }
    return stat.split('+').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('+');
  };

  const statKeys = Object.keys(props.stats);


  // Drag-to-scroll for desktop
  const scrollRef = useRef(null);
  let isDown = false;
  let startX;
  let scrollLeft;

  const handleMouseDown = (e) => {
    isDown = true;
    startX = e.pageX - scrollRef.current.offsetLeft;
    scrollLeft = scrollRef.current.scrollLeft;
    scrollRef.current.classList.add('dragging');
  };
  const handleMouseLeave = () => {
    isDown = false;
    scrollRef.current.classList.remove('dragging');
  };
  const handleMouseUp = () => {
    isDown = false;
    scrollRef.current.classList.remove('dragging');
  };
  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 1.5; // scroll-fast
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div
      ref={scrollRef}
      style={{
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        WebkitOverflowScrolling: 'touch',
        msOverflowStyle: 'none', // IE and Edge
        scrollbarWidth: 'none', // Firefox
        marginLeft: 0,
        marginRight: 0,
        cursor: 'grab',
        textAlign: 'left',
      }}
      className="hide-scrollbar"
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
    >
      {statKeys.map((stat) => (
        <button
          key={stat}
          onClick={props.onClick}
          className={'select-btn' + (props.stat === stat ? ' selected' : '')}
          data-prop='stat'
          value={stat}
          style={{ display: 'inline-block', marginRight: 12 }}
        >
          {formatStat(props.stats[stat])}
        </button>
      ))}
    </div>
  );

  return (
    <Slider {...settings}>

      {Object.keys(props.stats).map((stat) => (
        <button
          key={stat}
          onClick={props.onClick}
          className={'select-btn' + (props.stat === stat ? ' selected' : '')}
          data-prop='stat'
          value={stat}
        >
          {formatStat(props.stats[stat])}
        </button>
      ))}

    </Slider>
  );
};

export default StatSelection;